import { render } from "./ZenForm.vue?vue&type=template&id=6175462e&scoped=true&ts=true"
import script from "./ZenForm.vue?vue&type=script&lang=ts"
export * from "./ZenForm.vue?vue&type=script&lang=ts"

import "./ZenForm.vue?vue&type=style&index=0&id=6175462e&scoped=true&lang=css"

import exportComponent from "/Users/jiunjyechin/PhpstormProjects/Zenship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6175462e"]])

export default __exports__